import React, { memo, useMemo } from "react";
import { getDistributionGroupMention } from "modules/utils/Functions";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";

interface IProps {
  distributionGroupId: string;
}

const DistributionGroupName = ({ distributionGroupId }: IProps) => {
  const { distributionGroupsById } = useDistributionGroups();
  const distributionGroup = distributionGroupsById[distributionGroupId];
  const name = useMemo(() => {
    if (!distributionGroup) return;
    return getDistributionGroupMention(distributionGroup);
  }, [distributionGroup]);
  if (!name || !distributionGroup) return null;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment>{name}</React.Fragment>;
};

export default memo(DistributionGroupName);
